import { useCallback } from "react";
import { GoHome } from "react-icons/go";
import { NavBar, Page, PageHeader, PageHeaderProvider } from "@iq/models";
import aftrPrtyLogo from "../../assets/aftrprtylogo.png";
import useIsSmallScreen from "../../hooks/useIsSmallScreen";

// Shell for standalone staff pages that have no in-app navigation of their own.
function PageShell({ children }) {
    const isSmallScreen = useIsSmallScreen();

    const goHome = useCallback(() => {
        window.location.assign("/");
    }, []);

    return (
        <div className="crm-layout app">
            <div className="nav-section">
                {!isSmallScreen && (
                    <NavBar
                        activePage="Home"
                        navItems={[]}
                        onPageChange={() => {}}
                        footerAction={{
                            label: "Home",
                            icon: <GoHome size={24} />,
                            active: true,
                            onClick: goHome,
                        }}
                    />
                )}
            </div>
            <PageHeader
                title={<img src={aftrPrtyLogo} alt="AftrPrty Logo" style={{ height: "1.25rem" }} />}
            />
            <Page>{children}</Page>
        </div>
    );
}

export default PageShell;
